import { HelpersGroup } from "@eisinc/XDL/types";

const get = (spaces:any, size:string|number, cord:string) => {
  return `${spaces[size] ? `${spaces[size][cord]}` : size}px`;
};

const Sp = {
  // padding
  pa: ({ spaces }:any, size:string) => `padding: ${get(spaces, size, "y")} ${get(spaces, size, "x")};`,
  pl: ({ spaces }:any, size:string) => `padding-left: ${get(spaces, size, "x")};`,
  pr: ({ spaces }:any, size:string) => `padding-right: ${get(spaces, size, "x")};`,
  pt: ({ spaces }:any, size:string) => `padding-top: ${get(spaces, size, "y")};`,
  pb: ({ spaces }:any, size:string) => `padding-bottom: ${get(spaces, size, "y")};`,
  px: ({ spaces }:any, size:string) => `${Sp.pr(spaces, size)} ${Sp.pl(spaces, size)}`,
  py: ({ spaces }:any, size:string) => `${Sp.pt(spaces, size)} ${Sp.pb(spaces, size)}`,

  // margin
  ma: ({ spaces }:any, size:string) => `margin: ${get(spaces, size, "y")} ${get(spaces, size, "x")};`,
  ml: ({ spaces }:any, size:string) => `margin-left: ${get(spaces, size, "x")};`,
  mr: ({ spaces }:any, size:string) => `margin-right: ${get(spaces, size, "x")};`,
  mt: ({ spaces }:any, size:string) => `margin-top: ${get(spaces, size, "y")};`,
  mb: ({ spaces }:any, size:string) => `margin-bottom: ${get(spaces, size, "y")};`,
  mx: ({ spaces }:any, size:string) => `${Sp.mr(spaces, size)} ${Sp.ml(spaces, size)}`,
  my: ({ spaces }:any, size:string) => `${Sp.mt(spaces, size)} ${Sp.mb(spaces, size)}`,
} as HelpersGroup;

export default Sp;
